<!-- Provider Toolkit: Client drill-down (from mockup-provider-toolkit.html) -->

<h1 class="u-sr-only">{{ 'Sidebar.Menu.Toolkit' | translate }}</h1>
<section class="c-section c-section--first c-section--last c-section--open c-section--static u-no-pb">
	<div class="c-section__header">
		<h1 class="c-section__title c-section__title--sm">{{ 'Sidebar.Menu.Toolkit' | translate }}</h1>
		<p class="c-text c-text--gray toolkit__subtitle">{{ 'Toolkit.Subtitle' | translate }}</p>
	</div>
	<div class="c-section__content">
		<div class="o-grid">
			<div class="o-grid__cell c-cell">
				<div class="c-card toolkit ptkDetail">
					<loader-overlay *ngIf="vm.loading"></loader-overlay>

					<div class="main">
						<a class="back-link" href="javascript:void(0)" (click)="vm.back()">
							<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>
							{{ 'Toolkit.Provider.Client.Back' | translate }}
						</a>

						<div class="empty-pane" *ngIf="!vm.loading && vm.error">
							<h3>{{ 'Toolkit.Provider.Client.LoadError.Title' | translate }}</h3>
							<p>{{ 'Toolkit.Provider.Client.LoadError.Text' | translate }}</p>
						</div>

						<ng-container *ngIf="!vm.loading && !vm.error && vm.client">
							<div class="client-header">
								<div class="avatar-lg">{{ (vm.client.firstname?.[0] || '?') + (vm.client.lastname?.[0] || '') }}</div>
								<div>
									<h2>{{ vm.client.firstname }} {{ vm.client.lastname }}</h2>
									<div class="sub">{{ vm.client.email || '' }}</div>
								</div>
								<div class="actions">
									<button class="btn-secondary" type="button" (click)="vm.assign()">{{ 'Toolkit.Provider.Client.Actions.Assign' | translate }}</button>
									<button class="btn-secondary" type="button" (click)="vm.openChat()">{{ 'Toolkit.Provider.Client.Actions.Message' | translate }}</button>
								</div>
							</div>

							<div class="summary-row" *ngIf="vm.stats">
								<div class="summary-box box-completed">
									<div class="summary-label">{{ 'Toolkit.Provider.Client.Stats.ToolkitCompleted' | translate }}</div>
									<div class="summary-value val-green">{{ vm.stats.toolkitCompleted }}</div>
									<div class="summary-sub">{{ 'Toolkit.Provider.Client.Stats.Of' | translate }} {{ vm.stats.toolkitTotal }} {{ 'Toolkit.Provider.Client.Stats.Assigned' | translate }}</div>
								</div>
								<div class="summary-box box-overdue">
									<div class="summary-label">{{ 'Toolkit.History.Summary.Overdue' | translate }}</div>
									<div class="summary-value val-orange">{{ vm.stats.overdueCount }}</div>
									<div class="summary-sub">{{ vm.stats.overdueTitle || '—' }}</div>
								</div>
								<div class="summary-box box-surveys">
									<div class="summary-label">{{ 'Toolkit.Provider.Client.Stats.SurveyPending' | translate }}</div>
									<div class="summary-value val-purple">{{ vm.stats.surveyPendingCount }}</div>
									<div class="summary-sub">{{ vm.stats.surveyPendingLabel || '—' }}</div>
								</div>
							</div>

							<div class="section-title">
								<span>{{ 'Toolkit.Provider.Client.AssignedToolkits' | translate }}</span><span class="count">{{ vm.assignments?.length || 0 }} {{ 'Toolkit.Provider.Client.Total' | translate }}</span>
							</div>

							<div class="resource-grid">
								<div
									class="resource-card"
									*ngFor="let a of vm.assignments"
									[ngClass]="{ 'is-overdue': vm.statusPill('toolkit', a).cls === 'pill-overdue' }"
									(click)="vm.openExerciseResult(a)"
									style="cursor:pointer;">
									<div class="resource-card-head">
										<div>
											<div class="title">{{ a._resource?.title || a.resourceId }}</div>
											<div class="meta">
												{{ vm.themeName(a._resource?.themeId || a._resource?.theme_id || a._resource?.theme) | translate }}
												<span *ngIf="a._resource?.format"> · {{ vm.resourceFormatLabel(a._resource.format) | translate }}</span>
												<span *ngIf="a._resource?.difficulty"> · {{ vm.difficultyLabel(a._resource.difficulty) | translate }}</span>
												<span *ngIf="a._resource?.durationMinutes != null"> · {{ a._resource.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
											</div>
										</div>
										<span class="status-pill" [ngClass]="vm.statusPill('toolkit', a).cls"><span class="pill-dot"></span>{{ vm.statusPill('toolkit', a).key | translate }}</span>
									</div>
									<div class="note" *ngIf="a.note">"{{ a.note }}"</div>
									<div class="meta">
										<span *ngIf="a.completedAt">{{ 'Toolkit.Common.Completed' | translate }} {{ a.completedAt | date:'yyyy-MM-dd' }}</span>
										<span *ngIf="!a.completedAt">{{ 'Toolkit.Common.Assigned' | translate }} {{ a.assignedAt | date:'yyyy-MM-dd' }}</span>
										<span *ngIf="a.dueAt"> · {{ 'Toolkit.Common.Due' | translate }} {{ a.dueAt | date:'yyyy-MM-dd' }}</span>
									</div>
								</div>
								<div class="empty-pane" *ngIf="!vm.assignments?.length">
									<h3>{{ 'Toolkit.Provider.Client.EmptyToolkits.Title' | translate }}</h3>
									<p>{{ 'Toolkit.Provider.Client.EmptyToolkits.Text' | translate }}</p>
								</div>
							</div>

							<div class="section-title">
								<span>{{ 'Toolkit.Provider.Client.Surveys' | translate }}</span><span class="count">{{ vm.assessmentAssignments?.length || 0 }} {{ 'Toolkit.Provider.Client.Sent' | translate }}</span>
							</div>

							<div class="resource-grid">
								<div
									class="resource-card"
									*ngFor="let s of vm.assessmentAssignments"
									[ngClass]="{ 'is-overdue': vm.statusPill('survey', s).cls === 'pill-overdue' }"
									(click)="vm.openSurveyResult(s)"
									style="cursor:pointer;">
									<div class="resource-card-head">
										<div>
											<div class="title">{{ s._assessment?.title || s.assessmentId }}</div>
											<div class="meta">
												<span>{{ 'Toolkit.Assessment.Common.Badge' | translate }}</span>
												<span *ngIf="s._assessment?.durationMinutes != null"> · </span>
												<span *ngIf="s._assessment?.durationMinutes != null">{{ s._assessment.durationMinutes }} {{ 'Toolkit.Common.Minutes' | translate }}</span>
												<span *ngIf="s._assessment?.durationMinutes == null">—</span>
											</div>
										</div>
										<span class="status-pill" [ngClass]="vm.statusPill('survey', s).cls"><span class="pill-dot"></span>{{ vm.statusPill('survey', s).key | translate }}</span>
									</div>
										<div class="meta">
											<span *ngIf="s.completedAt">{{ 'Toolkit.Common.Completed' | translate }} {{ s.completedAt | date:'yyyy-MM-dd' }}</span>
											<span *ngIf="!s.completedAt">{{ 'Toolkit.Common.Sent' | translate }} {{ s.assignedAt | date:'yyyy-MM-dd' }}</span>
											<span *ngIf="s.dueAt"> · {{ 'Toolkit.Common.Due' | translate }} {{ s.dueAt | date:'yyyy-MM-dd' }}</span>
										</div>
								</div>
								<div class="empty-pane" *ngIf="!vm.assessmentAssignments?.length">
									<h3>{{ 'Toolkit.Provider.Client.EmptySurveys.Title' | translate }}</h3>
									<p>{{ 'Toolkit.Provider.Client.EmptySurveys.Text' | translate }}</p>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
